import { CompanyConfigurationModel } from "@common/tenant/company-configuration.model";
import { useQuery } from "@tanstack/react-query";
import { api, getUserSession } from "utils/api";

async function fetchCompanyConfigurations(): Promise<CompanyConfigurationModel | undefined> {
  const session = await getUserSession();

  if (!session) {
    return;
  }

  const response = await api.get("/tenant/company-configurations");
  return response.data;
}

export function useCompanyConfigurations() {
  return useQuery({
    queryKey: ["companyConfigurations"],
    queryFn: fetchCompanyConfigurations,
    staleTime: 4 * 60 * 60 * 1000, // 4 hours
  });
}
